export function getLocalStorageItemOrNull(key: string) {
    const row = localStorage.getItem(key)
    return row
}

export function getLocalStorageJsonItemOrNull(key: string) {
    const row = localStorage.getItem(key)
    if (row == 'undefined') {
        return null
    }

    if (row && row.length > 0) {
        return JSON.parse(row)
    }
    return null
}

export default getLocalStorageItemOrNull